import tw from "tailwind-styled-components";
import { Wrapper } from "../../Styles/InputStyles";

const UtilityBillSelectionScreen = ({ selectOptions, selectedOption, onOptionSelect }) => {
    const renderSelectionScreen = () => {
        return (
            <Wrapper>
                <DuesGroup>
                    {selectOptions.map((option) => {
                        return (
                            <DuesOption
                                key={option.value}
                                onClick={() => onOptionSelect(option.value)}
                            >
                                <RadioContainer>
                                    <RadioCircle
                                        isSelected={selectedOption === option.value}
                                    />
                                    <span className="text-sm text-gray-800">{option.label}</span>
                                </RadioContainer>
                            </DuesOption>
                        );
                    })}
                </DuesGroup>
            </Wrapper>
        );
    };

    return renderSelectionScreen();
};

// Styled Components

const DuesGroup = tw.div`flex flex-col gap-3`;
const DuesOption = tw.div`
    flex flex-col gap-2 p-4 border rounded-lg cursor-pointer
    transition-all duration-200 hover:bg-gray-100
`;
const RadioContainer = tw.div`flex items-center gap-3`;
const RadioCircle = ({ isSelected }) => (
    <div
        className={`w-3.5 h-3.5 rounded-full border-2 flex items-center justify-center ${isSelected ? "border-blue-500" : "border-gray-500"
            }`}
    >
        {isSelected && <div className="w-2 h-2 bg-blue-500 rounded-full" />}
    </div>
);

export default UtilityBillSelectionScreen;
